import script from "./NPCDesktopPet.vue?vue&type=script&setup=true&lang=js"
export * from "./NPCDesktopPet.vue?vue&type=script&setup=true&lang=js"

import "./NPCDesktopPet.vue?vue&type=style&index=0&id=23270378&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23270378"]])

export default __exports__